import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import Tour from "reactour";

//Services
import api from "../../../service/api";

//Components
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalShare";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";
import { TitleTour, ContentText } from "../../../components/ReactourComponents/styles";

//Styles
import { Legend, ButtonContainer, FormContainer } from "./styles";

//Routes
import routes from "../../../routes/subscription.routes";

//Help Functions
import {openModal} from "../../../helpers/modalFunctions"

//Assets
import search from "../../../assets/icons/search.svg";
import colors from "../../../assets/css/colors";

import { ToastContainer } from "react-toastify";

// Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import { calcExpDate } from "../../../utils/calcDateExpiration";
import ModalWarning from "../../../components/ModalWarning";

const PaymentLink = () => {
    const [recurrence, setRecurrence] = useState({
        id: "",
        name: "",
        planIdAdquirente: "",
        amount: "",
        description: "",
        frequency: "",
        duration: 0
    });
    const [debouncedRecurrenceName, setDebouncedRecurrenceName] = useState("");
    const [recurrenceSearchDataResults, setRecurrenceSearchDataResults] = useState<Array<any>>([]);

    const [buyer, setBuyer] = useState({
        id: "",
        firstName: "",
        latsName: "",
        buyerIdAdquirente: "",
        phoneNumber: "",
        email: ""
    });
    const [debouncedBuyerName, setDebouncedBuyerName] = useState("");

    const [buyerSearchDataResults, setBuyerSearchDataResults] = useState<Array<any>>([]);

    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);
    const [dateForExpiration, setDateForExpiration] = useState("");


    const [linkId, setLinkId] = useState({
        id: "",
        url: "",
        amount: 0,
        description: "",
        establishment: ""
    });

    const [message, setMessage] = useState("");

    const [isTutorialTourOpen, setIsTutorialTourOpen] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    useEffect(() => {
        if(login.user.groups.cm5a3 === false){
            history.push("/admin/dashboard");
        }

        if(query.get("tutorial") !== null) {
            setIsTutorialTourOpen(true);
        }
    }, []);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedRecurrenceName(recurrence.name);
        }, 300);
        
        return () => {
            clearTimeout(timerId);
        }
    }, [recurrence.name]);
    
    useEffect(() => {
        const getRecurrencePlansAtApi = async () => {

            const {data} = await api.get(`/adm/ownerbranch/list?id=${login.user.branchsId}&filter=${debouncedRecurrenceName}`);
            
            setRecurrenceSearchDataResults(data.Recurrence)
        }

        if(debouncedRecurrenceName !== ""){
            getRecurrencePlansAtApi();
        }
    }, [debouncedRecurrenceName]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedBuyerName(buyer.firstName);
        }, 300);
        
        return () => {
            clearTimeout(timerId);
        }
    }, [buyer.firstName]);
    
    useEffect(() => {
        const getBuyersAtApi = async () => {

            const {data} = await api.get("/buyer/list", {
                params: {
                    branchsId: login.user.branchsId,
                    search: debouncedBuyerName
                }
            });

            setBuyerSearchDataResults(data.Buyer)
        }

        if(debouncedBuyerName !== ""){
            getBuyersAtApi();
        }
    }, [debouncedBuyerName]);

    const formValidationWithYup = Yup.object().shape({
        dateForNextPayment: Yup.string().required()
    })

    const searchForErrors = (errors: Object) => {
        if(Object.keys(errors).length !== 0){
          setErrorOnSubmit(true)
        } else {
          setErrorOnSubmit(false)
        }
    }

    const sendEmail = async () => {
        try {
            const {data} = await api.post("linkpay/send/email", {
                email: buyer.email,
                link: linkId.url,
                id: linkId.id,
                buyer_name: `${buyer.firstName} ${buyer.latsName}`,
                establishment: login.user.branchs.businessName
            });

            setMessage("Email enviado com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar email")
        }

    }

    const sendWhatsapp = async () => {
        try {
            const {data} = await api.post("/linkpay/send/whats", {
                amount: Number(recurrence.amount),
                description: recurrence.description,
                establishment: login.user.branchs.businessDescription,
                link: `${linkId.url}`,
                phoneSms: `55${buyer.phoneNumber}`
            });

            setMessage("Mensagem enviada com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar mensagem")
        }
    }

    const stepsTutorial = [
        {
            selector: "#form-subscription",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Para criar um link de pagamento para a assinatura, preencha os campos.</ContentText>
                </div>
            )
        },
        {
            selector: "#button-submit",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Clique no botão e aguarde a abertura da tela de compartilhamento, a assinatura será criada, mas só será ativada quando o cliente adicionar um cartão por meio do link gerado</ContentText>
                </div>
            )
        },
        {
            selector: "",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Na tela de compartlhamento, você terá a opção de copiar o link ou compatilhá-lo via WhatsApp e/ou Email, para compartilhar, basta clicar no botão da opção escolhida e aguardar a confirmação de envio.</ContentText>
                </div>
            )
        },
    ];

    return(
        <Main>
            <ToastContainer />
            <ModalWarning 
                title="Logo não identificada"             
                description="Para criar links de pagamentos, é necessário fazer o upload da logo da sua empresa. Deseja ir para configurações?" 
                pathBack="/admin/subscription/recurrence-plan"
                pathGo="/admin/configuration/my-cadastre"
            />
            <Tour
                steps={stepsTutorial}
                isOpen={isTutorialTourOpen}
                onRequestClose={() => setIsTutorialTourOpen(false)}
                accentColor={colors.primary}
                showNumber={false}
                showNavigation
                showNavigationNumber={false}
                showButtons
            />
            <Header title="Assinatura" subTitle="Gere pagamentos via boleto bancário de forma fácil e rápida." subTitleWidth={236}/>
            <NavTabs tabs={routes}/>
            <Modal 
                text="Link gerado com sucesso" 
                linkId={`${linkId.url}`}
                type={3}
                sendEmail={sendEmail}
                sendWhatsapp={sendWhatsapp}
                message={message}
            />

            <Formik
                initialValues={{
                    description: "",
                    dateForNextPayment: ""
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values, { resetForm }) => {
                    let dueDate: Array<string> | string = values.dateForNextPayment.split("/");
                    let expirationDate: Array<string> | string = calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency).split("/");
                    
                    dueDate = `${dueDate[2]}-${dueDate[1]}-${dueDate[0]}`;
                    expirationDate = `${expirationDate[2]}-${expirationDate[1]}-${expirationDate[0]}`

                    try{
                        const {data} = await api.post("/subscription/create/linkpay", {  
                            "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                            "apiOwnerId": "ZOOP", //login.user.branchs.apiOwner.id
                            "idPlanAdquirente": recurrence.planIdAdquirente,
                            "idBuyerAdquirente": buyer.buyerIdAdquirente,
                            "amount": Number(recurrence.amount),
                            "name": `${values.description} - ${recurrence.name}`,
                            "description": `${values.description} - ${recurrence.description}`,
                            "due_date": dueDate,
                            "buyer100PayId": buyer.id,
                            "branchId": login.user.branchsId,
                            "owner100PayId": login.user.branchs.sellerOwner100PayId,
                            "planRecurrenceId": recurrence.id,
                            "expiration_date": expirationDate
                        });

                        const responseCreateLink = await api.post("linkpay/create", {
                            "branchsId": login.user.branchsId,
                            "buyersId": buyer.id,
                            "buyerIdAdquirente": buyer.buyerIdAdquirente,
                            "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                            "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
                            "amount": recurrence.amount,
                            "numberInstalments": recurrence.duration,
                            "description": `${values.description} - ${recurrence.description}`,
                            "phoneSms": buyer.phoneNumber,
                            "tpTransaction": "1", // assinatura
                            "standardLogo": login.user.branchs.standardLogo,
                            "email": buyer.email,
                            "idSubscription100Pay": data.subscription[0].idSubscription100Pay,
                            "idSubscriptionAdquirente": data.subscription[0].idSubscriptionAdquirente
                        });

                        // const linkShort = await api.get(`/link`, {
                        //     params: {
                        //         link: `https://100pay-payment-link.netlify.app/${responseCreateLink.data.id}/${login.token}`,
                        //     }
                        // });

                        setLinkId({
                            id: responseCreateLink.data.id,
                            url: `https://100pay-payment-link.netlify.app/${responseCreateLink.data.id}/${login.token}`,
                            amount: 0,
                            description: values.description,
                            establishment: login.user.branchs.businessDescription
                        });
                        setErrorOnReturnApi(false);
                        setMessage("");
                        openModal("exampleModal");
                        setErrorOnSubmit(false);
                        toastUpdate("btnSubmit","success",2000,"Sucesso" )
                        resetForm();
                    } catch (e){
                        setErrorOnReturnApi(true);
                        toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
                    }
                }}
            >
                {({errors, handleSubmit, handleChange, values}) => {
                    return(
                        <Form>
                            <FormContainer>
                                <fieldset>
                                    <div id="form-subscription">
                                        <Legend>Gerar um link para pagamento</Legend>
                                        <Field id="description" name="description" className="inputCustom" placeholder="Descrição" as={Input}/>
                                        <div className="inputWithIcon">
                                            <Input
                                            className="inputCustom"
                                            style={{borderColor: `${errorOnSubmit && buyer.buyerIdAdquirente === "" ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            placeholder="Comprador"
                                            type="search"
                                            autoComplete="off"
                                            isSearchField={true}
                                            setValue={setBuyer}
                                            searchType="name"
                                            searchResults={buyerSearchDataResults}
                                            value={buyer.firstName}
                                            onChange={(e: any) => {
                                                setBuyer({
                                                    id: buyer.id, 
                                                    firstName: e.target.value,
                                                    latsName: buyer.latsName,
                                                    buyerIdAdquirente: buyer.buyerIdAdquirente,
                                                    phoneNumber: `55${buyer.phoneNumber}`,
                                                    email: buyer.email
                                                });
                                            }}
                                            />
                                            <img src={search}/>
                                        </div>
                                        <div className="inputWithIcon">
                                            <Input 
                                                className="inputCustom" 
                                                style={{borderColor: `${errorOnSubmit && recurrence.id === "" ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                placeholder="Plano de Recorrência" 
                                                type="search"
                                                autoComplete="off"
                                                isSearchField={true}
                                                setValue={setRecurrence}
                                                searchResults={recurrenceSearchDataResults}
                                                searchType="name"
                                                value={recurrence.name}
                                                onChange={(e: any) => {
                                                    setRecurrence({
                                                        id: recurrence.id,
                                                        planIdAdquirente: recurrence.planIdAdquirente,
                                                        amount: recurrence.amount,
                                                        name: e.target.value,
                                                        description: recurrence.description,
                                                        frequency: recurrence.frequency,
                                                        duration: recurrence.duration
                                                    });
                                                }}
                                            />
                                            <img src={search}/>
                                        </div>
                                        <Field 
                                            name="dateForNextPayment" 
                                        >
                                            {() => (
                                            <InputMasked
                                                id="dateForNextPayment" 
                                                className="input-masked inputCustom" 
                                                style={{borderColor: `${errorOnSubmit && errors.dateForNextPayment ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                mask="99/99/9999" 
                                                placeholder="Data Próxima Cobrança"
                                                value={values.dateForNextPayment}
                                                onChange={handleChange}
                                                onChangeCapture={(e) => {
                                                    setDateForExpiration(e.currentTarget.value)
                                                }}
                                            />
                                            )}
                                        </Field>
                                        <Field 
                                            disabled
                                            name="dateForExpiration"
                                            style={{cursor: "no-drop"}}
                                            value={
                                                calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency) === "Data inválida"
                                                ? "Data de expiração"
                                                : calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency)
                                            }
                                            as={Input}
                                        />
                                    </div>
                                </fieldset>
                                {
                                    errorOnSubmit && buyer.buyerIdAdquirente === "" 
                                    ? toastUpdate("btnSubmit","warning",3000,"Selecione um cliente" )
                                    : null
                                }
                                {
                                    errorOnSubmit && recurrence.id === "" 
                                    ? toastUpdate("btnSubmit","warning",3000,"Selecione um plano de recorrência" )
                                    : null
                                }
                                {notifysFieldsForm(errors, errorOnSubmit)}

                                <ButtonContainer>
                                    {
                                        errorOnReturnApi ?
                                            <ErrorMessage>
                                                Falha ao gerar link de pagamento
                                            </ErrorMessage> : null
                                    }
                                    <Button 
                                        id="button-submit"
                                        type="submit"
                                        onClick={() => {
                                            searchForErrors(errors);
                                            toastCreate("btnSubmit", "info", 2000, "Processando")
                                        }}
                                    >
                                        Gerar link
                                    </Button>
                                </ButtonContainer>
                            </FormContainer>
                        </Form>
                    )
                }}


            </Formik>

        </Main>
    )
}

export default PaymentLink;